jQuery(document).ready(function($){

  $(".disclosure-list__item:not(.disclosure-list__item--current) .disclosure-list__option").first().clone().appendTo("#burger_menu .sidebar-right");

  var tlBurgerMenu = gsap.timeline({paused:true});
      tlBurgerMenu.fromTo(".inner_item.item_left .title_menu_top, .inner_item.item_right .item_right_left .title_menu_top", { autoAlpha:0, y:30 }, { autoAlpha:1, y:0, duration:0.4 }, "+=0.4");
      tlBurgerMenu.fromTo(".inner_burger_menu .inner_item.item_right .item_right_right a", {autoAlpha:0, y:30}, { autoAlpha:1, y:0, stagger:0.1}, "<");
      tlBurgerMenu.fromTo(".title_submenu_top", { autoAlpha:0, y:30 }, { autoAlpha:1, y:0, duration:0.3 }, "<");
      tlBurgerMenu.fromTo(".inner_item.item_left .sub_menu_top_item:nth-child(1) .list_item_submenu_top > a", {autoAlpha:0, y:30}, { autoAlpha:1, y:0, stagger:0.05});
      tlBurgerMenu.fromTo(".inner_item.item_left .sub_menu_top_item:nth-child(2) .list_item_submenu_top > a", {autoAlpha:0, y:30}, { autoAlpha:1, y:0, stagger:0.05}, "<");
      tlBurgerMenu.fromTo(".inner_item.item_right .list_item_submenu_top > a", {autoAlpha:0, y:30}, { autoAlpha:1, y:0, stagger:0.05}, "<");

  var tlBurgerMenuMobile = gsap.timeline({paused:true});
      tlBurgerMenuMobile.fromTo('.item_menu_mobile_group', { autoAlpha:0, y:30 }, { autoAlpha:1, y:0, stagger:0.05 });

  $(".btn-menu").on('click', function(){

    $("#burger_menu").addClass('active');
    tlBurgerMenu.restart();
    tlBurgerMenuMobile.restart();
    
  });

  $("#close-menu").on('click', function(){

    $("#burger_menu").removeClass('active');
    tlBurgerMenu.revert();
    tlBurgerMenuMobile.revert();
  });

  $(".list_item_submenu_top, .item_right_right").on('mouseenter', "a", function(){

    gsap.to($(this), {opacity:0.5});
    
  });

  $(".list_item_submenu_top, .item_right_right").on('mouseleave', "a", function(){

    gsap.to($(this), {opacity:1});
    
  });


  $(".trigger-menu-mobile").on('click', function(){

      $(this).parent().find('.sub_menu_mobile').stop().slideToggle();
    
  });

  $("#localization_formtoolbar").prependTo('body');
  setTimeout(function(){
    gsap.to("#localization_formtoolbar", { opacity:1 });
  }, 500);

  if ( $(".wrap-contact").length ){

      $(".wrap-contact input, .wrap-contact textarea").focus(function(){

        $(this).parent().addClass('active');
        
      });

      $(".wrap-contact input, .wrap-contact textarea").blur(function(){

        if ( $(this).val() == "" ){
          $(this).parent().removeClass('active');
        }
        
        
      });
    
  }

  if ( $(".testimonials-slider").length ){

      var sliderTestimonials = $('.testimonials-slider').slick({
        arrows: false
      });

      $(".testimonials-carousel-nav .slick-prev-slide").on('click', function(){ sliderTestimonials.slick('slickPrev'); });
      $(".testimonials-carousel-nav .slick-next-slide").on('click', function(){ sliderTestimonials.slick('slickNext'); });

      var currentCarousel = sliderTestimonials.slick('slickCurrentSlide');
      var countCarousel = sliderTestimonials.slick('getSlick');
      var currentSlide = parseInt(currentCarousel,10) + 1;
      var slideCount = countCarousel.slideCount
      if ( currentSlide < 10 ){
        currentSlide = "0"+currentSlide;
      }
      if ( slideCount < 10 ){
        slideCount = "0"+slideCount;
      }
      $(".testimonials-carousel-nav .current-page").html(currentSlide);
      $(".testimonials-carousel-nav .total-page").html(slideCount);

      sliderTestimonials.on('afterChange', function(event, slick, currentCarousel){
        var currentSlide = parseInt(currentCarousel,10) + 1;
        if ( currentSlide < 10 ){
          currentSlide = "0"+currentSlide;
        }
        $(".testimonials-carousel-nav .current-page").html(currentSlide);
      });
    
  }

  if ( $(".slider-standard-slider").length ){

      var sliderStandard = $('.slider-standard-slider').slick({
        arrows: false,
        adaptiveHeight: true
      });

      $(".slider-standard-carousel-nav .slick-prev-slide").on('click', function(){ sliderStandard.slick('slickPrev'); });
      $(".slider-standard-carousel-nav .slick-next-slide").on('click', function(){ sliderStandard.slick('slickNext'); });

      var currentCarousel = sliderStandard.slick('slickCurrentSlide');
      var countCarousel = sliderStandard.slick('getSlick');
      var currentSlide = parseInt(currentCarousel,10) + 1;
      var slideCount = countCarousel.slideCount
      if ( currentSlide < 10 ){
        currentSlide = "0"+currentSlide;
      }
      if ( slideCount < 10 ){
        slideCount = "0"+slideCount;
      }
      $(".slider-standard-carousel-nav .current-page").html(currentSlide);
      $(".slider-standard-carousel-nav .total-page").html(slideCount);

      sliderStandard.on('afterChange', function(event, slick, currentCarousel){
        var currentSlide = parseInt(currentCarousel,10) + 1;
        if ( currentSlide < 10 ){
          currentSlide = "0"+currentSlide;
        }
        $(".slider-standard-carousel-nav .current-page").html(currentSlide);
      });
    
  }
  
});